import React, { JSX, useEffect, useRef } from 'react';
import ReactDomServer from 'react-dom/server';
import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import { useHtmlTranslations } from 'contexts/LocalizationContext';

import { useScannedRelevosContext } from '../../../../contexts/ScannedRelevosContext';
import colors from '../../../../styles/colors';
import { ItemAssignmentSelectMode } from '../UserSelect/types';
import RelevosList from './RelevosList';
import SumUpConfirmButtons from './SumUpConfirmButtons';

const ReturnSumUp = (): JSX.Element | null => {
  const htmlTranslations = useHtmlTranslations();
  const { scannedRelevos, selectItemMode: scanMode, setScannedRelevos } = useScannedRelevosContext();

  const scrollToBottomRef = useRef<null | HTMLDivElement>(null);

  const scrollToBottom = () => {
    if (scrollToBottomRef.current) {
      scrollToBottomRef.current.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    if (scannedRelevos.length === 1) {
      scrollToBottom();
    }
  }, [scannedRelevos]);

  const removeRelevo = (relevo: string) => {
    setScannedRelevos((prevState) => prevState.filter((el) => el.uId !== relevo));
  };

  if (scannedRelevos.length === 0) {
    return (
      <VStack p={4}>
        <Box textAlign="left" pt={1} width={'100%'}>
          {[ItemAssignmentSelectMode.CAMERA_SCAN, ItemAssignmentSelectMode.HAND_SCANNER_SCAN].includes(scanMode) ? (
            <Text fontSize="20px">
              {htmlTranslations('relevos_scan_summary_heading', {
                '{{dishes-count}}': ReactDomServer.renderToString(
                  <Text as="b" color={'orange.500'}>
                    {scannedRelevos.length}
                  </Text>,
                ),
              })}
            </Text>
          ) : null}
        </Box>
        <Box textAlign="left" width={'100%'}>
          <Text fontSize="20px">{htmlTranslations('return_relevos_info')}</Text>
        </Box>
        <Box textAlign="left" width={'100%'}>
          <Text color="grey.200">{htmlTranslations('return_relevos_info_extended')}</Text>
        </Box>
      </VStack>
    );
  }

  if (scannedRelevos.length >= 1) {
    return (
      <Box ref={scrollToBottomRef} backgroundColor={colors.white}>
        <Flex direction="column" px={2} textAlign="left" pt={1}>
          <Flex justifyContent="space-between" alignItems="baseline" wrap="wrap">
            <Text fontSize="20px" mb={4} mr={4}>
              {htmlTranslations('relevos_scan_summary_heading', {
                '{{dishes-count}}': ReactDomServer.renderToString(
                  <Text as="b" color={'orange.500'}>
                    {scannedRelevos.length}
                  </Text>,
                ),
              })}
            </Text>
            <Box>
              <SumUpConfirmButtons />
            </Box>
          </Flex>
          <RelevosList onRemoveItem={removeRelevo} />
        </Flex>
      </Box>
    );
  }
  return <></>;
};

export default ReturnSumUp;
